import React from 'react'
import TemplatePageLayout from 'container/TemplatePageLayout'

const Template: React.FC = () => {
	return <TemplatePageLayout />
}

export default Template
